function send_a_message(uid) {
    var $ = jQuery.noConflict();
    console.log(uid);
}